import { render, staticRenderFns } from "./QuizQuestions.vue?vue&type=template&id=3aa5215a&scoped=true&"
import script from "./QuizQuestions.vue?vue&type=script&lang=js&"
export * from "./QuizQuestions.vue?vue&type=script&lang=js&"
import style0 from "./QuizQuestions.vue?vue&type=style&index=0&id=3aa5215a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5215a",
  null
  
)

export default component.exports